(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-read-more"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bp-read-more')) {
    customElements.define('bp-read-more', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.content = this.querySelector('.bp-read-more__content');
        this.button = this.querySelector('button');
        this.button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          this.button.setAttribute('aria-expanded', String(expanded));
          this.button.textContent = expanded ? this.dataset.less : this.dataset.more;
        });
        const update = () => {
          if (this.classList.contains('is-expanded')) return;
          this.classList.add('is-collapsible');
          const overflowing = this.content.scrollHeight > this.content.clientHeight + 2;
          this.classList.toggle('is-collapsible', overflowing);
          this.button.hidden = !overflowing;
        };
        requestAnimationFrame(update);
        document.fonts.ready.then(update);
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.previousWidth) { this.previousWidth = width; update(); }
        });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
